import Skeleton from "@mui/material/Skeleton";
import PageWrapper from "../../../components/PageWrapper";

const RenderLoading = () => {
  return (
    <PageWrapper>
      <div className="card h-full w-full flex flex-col">
        <div className="h-[30%] mb-2 w-full flex flex-col justify-between">
          <div className="h-1/3 mb-2 w-full flex justify-between">
            <div className="w-4/5 flex flex-col justify-center items-start">
              <Skeleton
                className="w-16 mb-2"
                height="30%"
                variant="rectangular"
              />
              <Skeleton className="w-3/5" height="50%" variant="rectangular" />
            </div>
            <div className="w-1/5 flex items-center justify-end">
              <Skeleton
                className="w-20 mr-2"
                height="40%"
                variant="rectangular"
              />
              <Skeleton className="w-20" height="40%" variant="rectangular" />
            </div>
          </div>
          <Skeleton height="70%" variant="rectangular" />
        </div>
        <Skeleton height="70%" variant="rectangular" />
      </div>
    </PageWrapper>
  );
};

export default RenderLoading;
